"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.appLayoutContentId = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _find = _interopRequireDefault(require("lodash/find"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _skipNavigationLink = _interopRequireDefault(require("../_skip-navigation-link"));

var _theme = require("../theme");

var _box = _interopRequireDefault(require("../box"));

var _propTypes2 = _interopRequireDefault(require("./../_prop-types"));

var _isElementOf = _interopRequireDefault(require("./../_utils/is-element-of"));

var _token = require("./../_utils/token");

var _functional = require("./../_utils/functional");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var appLayoutContentId = (0, _uniqueId["default"])("app-layout-content-"); // Remove the default margin on the body tag

exports.appLayoutContentId = appLayoutContentId;
(0, _emotion.injectGlobal)({
  body: {
    margin: 0
  }
});
/**
 * These styles are applied to the outer element of the app layout, whatever
 * that ends up being (e.g. just the content, the content locked up with a
 * masthead, etc.)
 */

var styles = (0, _functional.memoize)(function (backgroundColor) {
  return (0, _emotion.css)({
    backgroundColor: backgroundColor,
    height: [// Take up 100% of the viewport height. This has wide browser support but
    // introduces an issue on mobile browsers that can be solved by the following
    // value.
    "100vh", // If the browser supports it, use dynamic viewport height to take care of
    // that pesky problem where the browser UI changes the perceived height of
    // the webpage.
    //
    // https://www.bram.us/2021/07/08/the-large-small-and-dynamic-viewports/
    "100dvh"],
    "@media print": {
      height: "auto"
    }
  });
});
/**
 * These styles are applied to the scrollable content area. This will either be
 * just the app content, or a lockup of the app content and the app footer.
 */

var scrollerStyles = (0, _functional.memoize)(function (alwaysShowScrollbar) {
  return (0, _emotion.css)({
    overflowY: alwaysShowScrollbar ? "scroll" : "auto",
    outline: "none",
    "@media print": {
      overflowY: "visible"
    }
  });
});
/**
 * These styles are applied to a container with the content as the first child
 * and the app footer as the second child. The goal is to float the footer down
 * to the very bottom of the container.
 */

var footerLockupStyles = (0, _emotion.css)({
  // Lockup container styles
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  // Content styles
  "& > *:first-child": {
    flex: "auto",
    flexShrink: 0
  },
  // Footer styles
  "& > *:last-child": {
    flexShrink: 0,
    "@media print": {
      display: "none"
    }
  }
});
/**
 * These styles are applied to a container with the sidebar as the first child,
 * the content (or content + footer) as the second child, and the sheet as the third.
 * The goal is to arrange the sidebar and sheet to the start and end of the content
 * and to keep both children at full height.
 */

var sidebarAndSheetLockupStyles = (0, _emotion.css)({
  // Lockup container styles
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch",
  overflow: "hidden",
  // Content/footer styles
  "& > *:not([mdn-sidebar]):not([mdn-sheet])": {
    flex: "auto",
    minWidth: 0
  },
  // Sidebar and sheet styles
  "& > [mdn-sidebar], & > [mdn-sheet]": {
    display: "flex",
    alignItems: "stretch",
    flexShrink: 0,
    "@media print": {
      display: "none"
    }
  }
});
/**
 * These styles are applied to a container with the header as the first child
 * and the content (or content/footer/sidebar lockup) as the second child. The
 * goal is to stack the elements vertically with the header taking up only the
 * space it needs and the content taking up the rest of the space.
 */

var headerLockupStyles = (0, _emotion.css)({
  // Lockup container styles
  display: "flex",
  flexDirection: "column",
  // Header styles
  "& > *:first-child": {
    flexShrink: 0,
    "@media print": {
      display: "none"
    }
  },
  // Content/footer/sidebar styles
  "& > *:last-child": {
    flex: "auto"
  }
});
/**
 * Use this component at the root of your application to position a header,
 * sidebar, and footer region (or any subset of those regions) around a
 * scrollable content region.
 *
 * The AppLayout component accepts components for all regions (header, sidebar,
 * footer, and content) as children. The headerComponent, sidebarComponent, and
 * footerComponent props are used to identify which components should be placed
 * in which regions. All other components will be placed in the content region.
 *
 * The scrollable content area is given a unique id that makes it easy to query
 * in the DOM, allowing you to manually set the scroll position if necessary.
 * This id can be fetched by importing `appLayoutContentId` from the app-layout
 * module.
 *
 * Note that only one instance of AppLayout can be rendered at a time.
 */

function AppLayout(props) {
  var children = _react["default"].Children.toArray(props.children);

  var header = (0, _find["default"])(children, (0, _isElementOf["default"])(props.headerComponent));
  var sidebar = (0, _find["default"])(children, (0, _isElementOf["default"])(props.sidebarComponent));
  var sheet = (0, _find["default"])(children, (0, _isElementOf["default"])(props.sheetComponent));
  var footer = (0, _find["default"])(children, (0, _isElementOf["default"])(props.footerComponent));
  var t = (0, _theme.useTheme)();
  var backgroundColor = (0, _react.useMemo)(function () {
    return (0, _token.getToken)(t.tokens, "themeBackground", [props.backgroundColor, "default"]) || props.backgroundColor;
  }, [t, props.backgroundColor]); // Wrap the app content

  var content = /*#__PURE__*/_react["default"].createElement(_box["default"], {
    tag: "main",
    spacingInset: props.spacingInset,
    className: props.mainClassName
  }, children.filter(function (child) {
    return child !== header && child !== sidebar && child !== sheet && child !== footer;
  })); // If we have a footer, create a vertical lockup of that below the content.


  var footerLockup = footer ? /*#__PURE__*/_react["default"].createElement("div", {
    className: footerLockupStyles
  }, content, footer) : content; // Add an id to the content or footer/content lockup. This can be used to
  // target the content with a skip navigation link, and to query the element
  // via JS in order to set the scroll position of the content.

  var scroller = /*#__PURE__*/_react["default"].cloneElement(footerLockup, {
    id: appLayoutContentId,
    tabIndex: "-1",
    className: (0, _emotion.cx)(footerLockup.props.className, scrollerStyles(props.alwaysShowScrollbar))
  }); // If we have a sidebar or sheet, create a horizontal lockup of that in the order
  // sidebar | content | sheet


  var sidebarLockup = sidebar || sheet ? /*#__PURE__*/_react["default"].createElement("div", {
    className: sidebarAndSheetLockupStyles
  }, sidebar && /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-sidebar": ""
  }, sidebar), scroller, sheet && /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-sheet": ""
  }, sheet)) : scroller; // If we have a header, create a vertical lockup of that above the content.

  var headerLockup = header ? /*#__PURE__*/_react["default"].createElement("div", {
    className: headerLockupStyles
  }, /*#__PURE__*/_react["default"].createElement("div", null, header), sidebarLockup) : sidebarLockup; // Add our root styles to whatever element ended up being the outer wrapper.

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, header || sidebar ? /*#__PURE__*/_react["default"].createElement(_skipNavigationLink["default"], {
    targetId: appLayoutContentId
  }, props.skipNavigationMessage) : null, /*#__PURE__*/_react["default"].cloneElement(headerLockup, {
    className: (0, _emotion.cx)(headerLockup.props.className, styles(backgroundColor))
  }));
}

AppLayout.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Turn this on to always show a vertical scrollbar for the application's
   * content, regardless of whether the content overflows or not. This is
   * helpful in preventing the sideways jitter caused by a scrollbar appearing
   * and disappearing for pages with dynamic content.
   *
   * NOTE: This will have no visual impact on systems where scrollbars do not
   * affect the page layout (e.g. macOS with the default settings).
   */
  alwaysShowScrollbar: _propTypes["default"].bool,

  /**
   * The application's background color. Any CSS color value is acceptable.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary", "alternatePrimary", "alternateSecondary"]), _propTypes["default"].string]),

  /**
   * The main content of the application to be shown in a scrollable area
   * underneath the header, beside the sidebar, and above the footer.
   */
  children: _propTypes["default"].node,

  /**
   * The React component that will be used to render the footer.
   *
   * If your component is wrapped in a higher-order component, make sure that
   * the resulting component has a static property `WrappedComponent` that is
   * equivalent your original component.
   */
  footerComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),

  /**
   * The React component that will be used to render the header (e.g.
   * `Masthead` if you're using Meridian's Masthead directly).
   *
   * If your component is wrapped in a higher-order component, make sure that
   * the resulting component has a static property `WrappedComponent` that is
   * equivalent your original component.
   */
  headerComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),

  /**
   * A class to add to the `<main>` element's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   * The `<main>` element wraps the application's content.
   */
  mainClassName: _propTypes["default"].string,

  /**
   * The React component that will be used to render the sheet which will appear
   * opposite the `sidebarComponent`.
   *
   * If your component is wrapped in a higher-order component, make sure that
   * the resulting component has a static property `WrappedComponent` that is
   * equivalent your original component.
   */
  sheetComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),

  /**
   * The React component that will be used to render the sidebar (e.g.
   * `SideMenu` if you're using Meridian's SideMenu directly).
   *
   * If your component is wrapped in a higher-order component, make sure that
   * the resulting component has a static property `WrappedComponent` that is
   * equivalent your original component.
   */
  sidebarComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),

  /**
   * The message to display in the skip navigation link that allows users to
   * skip past the header and sidebar to the application content. This will
   * only be used if a header or sidebar is present.
   */
  skipNavigationMessage: _propTypes["default"].string,

  /**
   * Apply padding around the application content.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"100 none none none"` for 2px
   * padding on the top and 0px padding on the end, bottom, and starting sides).
   */
  spacingInset: _propTypes2["default"].spacing(4)
} : {};
AppLayout.defaultProps = {
  alwaysShowScrollbar: true,
  backgroundColor: "primary",
  skipNavigationMessage: "Skip to main content.",
  spacingInset: "none"
};
var _default = AppLayout;
exports["default"] = _default;